var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5638 12.696V1.30396H1.4375V12.696H2.07039L3.33618 11.4303L4.60197 12.696L5.86776 11.4303L7.13354 12.696L8.39933 11.4303L9.66512 12.696",
    stroke: "#474F60"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.00098,
    y: 4.5,
    width: 5,
    height: 1,
    fill: "#474F60"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.00098,
    y: 7,
    width: 2.5,
    height: 1,
    fill: "#474F60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRequest);
export default __webpack_public_path__ + "static/media/icon_request.ba597353e656d3cc4253c04dfc4aaab6.svg";
export { ForwardRef as ReactComponent };